import { useCallback } from 'react'
import { UserInformationUpdate } from 'Services/apiResponseTypes'
import { CellChange } from '../gridModel'

export const useMetadataSubmit = (
  employerId: number | undefined,
  changes: Map<string, CellChange>,
  validationErrors: Map<string, string>,
  updateMetadata: (params: {
    employerId: number
    updates: UserInformationUpdate[]
  }) => Promise<unknown>
) => {
  const handleSubmit = useCallback(async () => {
    if (!employerId || changes.size === 0 || validationErrors.size > 0) {
      return
    }

    const updatesByUser = new Map<number, UserInformationUpdate>()

    changes.forEach((change) => {
      if (!updatesByUser.has(change.userId)) {
        updatesByUser.set(change.userId, { user_id: change.userId })
      }

      const update = updatesByUser.get(change.userId)!
      if (change.kind === 'userField') {
        update.user_fields = { ...update.user_fields, [change.field]: change.newValue }
      } else {
        update.metadata = { ...update.metadata, [change.field]: change.newValue }
      }
    })

    await updateMetadata({ employerId, updates: Array.from(updatesByUser.values()) })
  }, [employerId, changes, validationErrors, updateMetadata])

  return { handleSubmit }
}
